import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export function ChatbotPage() {
  const { t } = useTranslation('data');

  return (
    <>
      <Helmet>
        <title>{t('musicIq.pageTitle')}</title>
      </Helmet>
      <div>{t('musicIq.chatbotPage')}</div>
    </>
  );
}

ChatbotPage.displayName = 'ChatbotPage';
